import React from 'react';
import './SeriesThumbnail.css';

function SeriesThumbnail({ thumbnailUrl, label, sliceCount, onClick }) {
    return (
        <div
            className="series-thumbnail-card"
            onClick={onClick}
            style={{
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '4px',
                width: '100%',
                minWidth: 0
            }}
            title={label}
        >
            <div
                style={{
                    width: '100%',
                    aspectRatio: '1 / 1',
                    background: '#000',
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
                onContextMenu={(e) => e.preventDefault()}
            >
                {thumbnailUrl ? (
                    <img
                        src={thumbnailUrl}
                        alt={label}
                        draggable={false}
                        style={{
                            position: 'absolute',
                            inset: 0,
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                            display: 'block'
                        }}
                    />
                ) : (
                    <div style={{ color: '#777', fontSize: '11px' }}>
                        Loading…
                    </div>
                )}
            </div>
            <div style={{
                fontSize: '12px',
                marginTop: '4px',
                width: '100%',
                textAlign: 'center',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                color: '#333'
            }}>
                {label}
            </div>
            <div style={{ fontSize: '11px', color: '#777' }}>
                {sliceCount} {sliceCount === 1 ? 'slice' : 'slices'}
            </div>
        </div>
    );
}

export default SeriesThumbnail;